import React, { useState, useEffect } from 'react';
import './InstallBanner.css';

const DISMISS_KEY = 'pwa_install_dismissed_at';
const DISMISS_DAYS = 7;

const InstallBanner = () => {
  const [installEvent, setInstallEvent] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Не показываем, если уже установлено или недавно отклонено
    if (window.matchMedia('(display-mode: standalone)').matches) return;
    const dismissedAt = Number(localStorage.getItem(DISMISS_KEY) || 0);
    if (Date.now() - dismissedAt < DISMISS_DAYS * 24 * 3600 * 1000) return;

    const onBeforeInstall = (e) => {
      e.preventDefault();
      setInstallEvent(e);
      // Показываем баннер с небольшой задержкой, чтобы не мешать входу
      setTimeout(() => setVisible(true), 4000);
    };

    const onInstalled = () => {
      setVisible(false);
      setInstallEvent(null);
    };

    window.addEventListener('beforeinstallprompt', onBeforeInstall);
    window.addEventListener('appinstalled', onInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', onBeforeInstall);
      window.removeEventListener('appinstalled', onInstalled);
    };
  }, []);

  const handleInstall = async () => {
    if (!installEvent) return;
    installEvent.prompt();
    const { outcome } = await installEvent.userChoice;
    if (outcome === 'dismissed') {
      localStorage.setItem(DISMISS_KEY, String(Date.now()));
    }
    setVisible(false);
    setInstallEvent(null);
  };

  const handleDismiss = () => {
    localStorage.setItem(DISMISS_KEY, String(Date.now()));
    setVisible(false);
  };

  if (!visible || !installEvent) return null;

  return (
    <div className="install-banner" data-testid="pwa-install-banner">
      <img src="/icon-192.png" alt="Тұрғын" className="install-banner-icon" />
      <div className="install-banner-text">
        <strong>Тұрғын</strong>
        <span>Орнату / Установить приложение на главный экран</span>
      </div>
      <button
        className="install-banner-btn"
        onClick={handleInstall}
        data-testid="pwa-install-btn"
      >
        Орнату
      </button>
      <button
        className="install-banner-close"
        onClick={handleDismiss}
        aria-label="Закрыть"
        data-testid="pwa-install-dismiss"
      >
        ✕
      </button>
    </div>
  );
};

export default InstallBanner;
